var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-cascader", {
    ref: "relDepartment",
    attrs: {
      placeholder: "请选择部门",
      options: _vm.departmentList,
      filterable: "",
      props: _vm.defaultProps,
      "change-on-select": "",
      clearable: "",
      "show-all-levels": false
    },
    on: { change: _vm.changeAddress },
    model: {
      value: _vm.departmentValue,
      callback: function($$v) {
        _vm.departmentValue = $$v
      },
      expression: "departmentValue"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }